import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  unit?: string;
  subValue?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendLabel?: string;
  highlight?: 'green' | 'amber' | 'red' | 'none';
  size?: 'sm' | 'md' | 'lg';
}

export default function StatCard({
  label,
  value,
  unit,
  subValue,
  trendLabel,
  highlight = 'none',
  size = 'md',
}: StatCardProps) {
  const highlightClass = {
    green: 'score-green border',
    amber: 'score-amber border',
    red: 'score-red border',
    none: 'card-forge',
  }[highlight];

  const valueSize = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl',
  }[size];

  return (
    <div className={`${highlightClass} p-4 rounded-lg`}>
      <div className="text-forge-label mb-2">{label}</div>
      <div className={`font-tabular font-black ${valueSize} leading-none flex items-baseline gap-1`}>
        {value}
        {unit && <span className="text-sm font-medium text-muted-foreground">{unit}</span>}
      </div>
      {subValue && <div className="text-xs text-muted-foreground mt-1 font-tabular">{subValue}</div>}
      {trendLabel && <div className="text-2xs text-muted-foreground mt-2 tracking-wide">{trendLabel}</div>}
    </div>
  );
}